import { observer } from 'mobx-react-lite';
import React from 'react';
import Notification from '~/components/Notification';
import PresetCard from '~/components/PresetCard';
import ScenarioEditor from '~/components/ScenarioEditor';
import Drawer from '~/components/ui/Drawer';
import SidebarTabs, { SidebarTab } from '~/components/ui/SidebarTabs';
import ScenarioTemplateModel from '~/models/ScenarioTemplateModel';
import { IScenarioProxyComponent } from '~/screens/ScenariosScreen/types';

export const ScenariosTemplates = observer(({ self }: IScenarioProxyComponent) => {
  const {
    store,
    isFeedback,
    state,
  } = self;

  const handleCloseCreate = () => {
    self.setState({ isTemplatesVisible: false });
  };

  const handleClickPreset = (id: string) => {
    self.setState({ selectedPreset: id });
  };

  const handleClosePreset = () => {
    if (self.store.scenarioEditingStatus === 'edited') {
      self.setState({ selectedPreset: null });
    } else {
      self.store.setScenarioEditingStatus('editing');
    }
  };

  const handleCloseHow = () => {
    self.setState({ isHowVisible: false });
  };

  const handleClickHow = () => {
    self.setState({ isHowVisible: true });
  };

  const handleSidebarTabsChange = (selectedGroup: string) => {
    self.setState({ selectedGroup: parseInt(selectedGroup, 10) });
  };

  if (store.getTemplateGroups(isFeedback).length === 0) return null;

  const tabs: SidebarTab[] = store
    .getTemplateGroups(isFeedback)
    .map((group: { ui: { caption: any } }, index: any) => {
      return { key: String(index), label: group.ui.caption };
    });

  const currentGroup = store.getTemplateGroups(isFeedback)[state.selectedGroup];

  const description = (
    <div dangerouslySetInnerHTML={{ __html: currentGroup.ui.description }} />
  );

  return (
    <Drawer
      visible={state.isTemplatesVisible}
      onClose={handleCloseCreate}
      title="Создать виджет"
      size="large"
    >
      <>
        <SidebarTabs
          tabs={tabs}
          value={String(state.selectedGroup)}
          onChange={handleSidebarTabsChange}
        >
          <div className="scenarios-screen-subscreen">
            <a
              className="scenarios-screen-subscreen__how"
              onClick={handleClickHow}
            >
              Как работают эти виджеты?
            </a>
            <div className="scenarios-screen-subscreen__title">
              {currentGroup.ui.caption}
            </div>
            {currentGroup.ui.subTitle && (
              <div className="scenarios-screen-subscreen__sub-title">
                {currentGroup.ui.subTitle}
              </div>
            )}

            <div className="scenarios-screen-subscreen__list">
              {store
                .getTemplatesByGroupIndex(state.selectedGroup, isFeedback)
                ?.map((template: ScenarioTemplateModel) => (
                  <PresetCard
                    className="scenarios-screen-subscreen__preset"
                    id={template.id}
                    key={template.key}
                    title={template.get('ui').name}
                    onClick={handleClickPreset}
                    tag={template.triggerParams.tag}
                    tagColor={template.triggerParams.tagColor}
                  >
                    <Notification
                      className="scenarios-screen-subscreen__notification"
                      {...template.triggerParams}
                    />
                  </PresetCard>
                ))}
            </div>
          </div>
        </SidebarTabs>

        <Drawer
          visible={state.isHowVisible}
          onClose={handleCloseHow}
          size="x-small"
          title={currentGroup.ui.caption}
          description={description}
          className="scenarios-screen-subscreen__drawer"
        />

        <Drawer
          visible={!!state.selectedPreset}
          title={currentGroup ? `Виджет «${currentGroup.ui.caption}»` : ''}
          onClose={handleClosePreset}
          size="large"
          flexBody
        >
          {state.selectedPreset && (
            <ScenarioEditor
              scenarioEditingStatus={store.scenarioEditingStatus}
              setScenarioEditingStatus={store.setScenarioEditingStatus}
              preset={store
                .getTemplateByScenarioCode(state.selectedPreset, isFeedback)
                ?.copy()}
              onClose={handleClosePreset}
              onSave={self.handleSaveScenario}
            />
          )}
        </Drawer>
      </>
    </Drawer>
  );
});
